import React from 'react'
import './HeroStyle.css'
import {BsLinkedin, BsGithub} from 'react-icons/bs'
import { Link } from 'react-scroll'
const Hero = () => {
  return (
    <div className='hero' >
      <div className="Container">
        <div className="content">
          <div className="main-hero">
          <div className="Left-side">
        <h1>Front-End React Developer  </h1>
        {/* <span><img src="./Images/waving.png" alt="hi" style={{width:'4rem',height:'4rem',marginRight:'2rem'}} /></span> */}
        <p>A salam Alaikum, I'm Muhammad Bilal. A passionate Front-end React Developer based in Peshawar, Pakistan. 📍</p>
         <div className="social-icon">
        <a href="https://github.com/Bilal7659" target='-blink'>< BsLinkedin style={{fontSize:'1.8rem'}}/></a>
        <a href="https://www.linkedin.com/in/muhammad-bilal-ahmad-6aa532224/" target='-blank'><BsGithub style={{fontSize:'1.8rem',marginLeft:'1.2rem'}}/></a>
         </div>
        
      </div>
      <div className="Right-side"></div>
          </div>
        </div>
        <div className="skill">
          <p>Tech Stack!</p>
          <div className="skills-logo">
            <ul>
              <li><img src="./Images/html.png" title='Html5' alt="html" /></li>
              <li><img src="./Images/css.png" title='css3' alt="css" /></li>
              <li><img src="./Images/js.png" title='Javascript' alt="js" /></li>
              <li><img src="./Images/react.png" title='React' alt="react" /></li>
              <li><img src="./Images/bootstrape.png" title='Bootstrape' alt="bootsrape" /></li>
              <li><img src="./Images/icons8-api-48.png" title='Api Integration' alt="bootsrape" /></li>
            </ul>
          </div>
         </div>
      </div>
   </div>
  )
}

export default Hero
